module.exports = "/packs/006-cbae1c85ab1717bb877510805cdcf4f1.jpg";